import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="custom-tabs"
export default class extends Controller {
  static targets = ["button", "pane"]

  connect() {
    console.log("Custom tabs connected", {
      buttons: this.buttonTargets.length,
      panes: this.paneTargets.length
    })

    this.disableInactivePanes()
  }

  showInitialTab() {
    const firstPane = this.paneTargets[0]
    if (firstPane && !firstPane.classList.contains('active')) {
      firstPane.classList.add('active')
    }
  }

  switch(event) {
    event.preventDefault()
    event.stopPropagation()

    const tabName = event.currentTarget.dataset.tab
    console.log('Switching to:', tabName)

    this.closeAllAccordions()

    const currentActivePane = this.paneTargets.find(pane =>
      pane.classList.contains('active')
    )
    if (currentActivePane) {
      this.disableInputs(currentActivePane)
    }

    this.buttonTargets.forEach(btn => btn.classList.remove('active'))
    this.paneTargets.forEach(pane => pane.classList.remove('active'))

    event.currentTarget.classList.add('active')
    const selectedPane = this.paneTargets.find(pane => pane.dataset.pane === tabName)

    if (selectedPane) {
      selectedPane.classList.add('active')

      this.enableInputs(selectedPane)

      setTimeout(() => {
        this.reinitializeAccordions(selectedPane)
      }, 50)
    }
  }

  disableInputs(pane) {
    const inputs = pane.querySelectorAll('input:not([type="hidden"]), textarea, select')
    inputs.forEach(input => {
      if (!input.dataset.originalDisabled) {
        input.dataset.originalDisabled = input.disabled
      }
      input.disabled = true
    })
  }

  enableInputs(pane) {
    const inputs = pane.querySelectorAll('input:not([type="hidden"]), textarea, select')
    inputs.forEach(input => {
      if (input.dataset.originalDisabled === 'true') {
        input.disabled = true
      } else {
        input.disabled = false
      }
    })
  }

  disableInactivePanes() {
    this.paneTargets.forEach(pane => {
      if (!pane.classList.contains('active')) {
        this.disableInputs(pane)
      }
    })
  }

  closeAllAccordions() {
    const allAccordions = this.element.querySelectorAll('.collapse.show')
    allAccordions.forEach(accordion => {
      if (typeof $ !== 'undefined') {
        $(accordion).collapse('hide')
      }
    })
  }

  reinitializeAccordions(pane) {
    const accordions = pane.querySelectorAll('[data-toggle="collapse"]')

    if (typeof $ !== 'undefined') {
      accordions.forEach(accordion => {
        $(accordion).off('click.bs.collapse')
      })
    }
  }
}
